var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3346 10.708H9.66797C9.3263 10.708 9.04297 10.4247 9.04297 10.083C9.04297 9.74134 9.3263 9.45801 9.66797 9.45801H26.3346C26.6763 9.45801 26.9596 9.74134 26.9596 10.083C26.9596 10.4247 26.6763 10.708 26.3346 10.708Z",
    fill: "#D9CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0586 10.083V20.058C11.0586 20.8747 11.4419 21.6497 12.1003 22.1413L16.4419 25.3913C17.3669 26.083 18.6419 26.083 19.5669 25.3913L23.9086 22.1413C24.5669 21.6497 24.9503 20.8747 24.9503 20.058V10.083H11.0586ZM21.3336 19.458H14.6669C14.3253 19.458 14.0419 19.1747 14.0419 18.833C14.0419 18.4913 14.3253 18.208 14.6669 18.208H21.3336C21.6753 18.208 21.9586 18.4913 21.9586 18.833C21.9586 19.1747 21.6753 19.458 21.3336 19.458ZM21.3336 15.2913H14.6669C14.3253 15.2913 14.0419 15.008 14.0419 14.6663C14.0419 14.3247 14.3253 14.0413 14.6669 14.0413H21.3336C21.6753 14.0413 21.9586 14.3247 21.9586 14.6663C21.9586 15.008 21.6753 15.2913 21.3336 15.2913Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.ceed036321ce7b92ac099df9d1f04e41.svg";
export { ForwardRef as ReactComponent };